import { AnyAction } from 'redux';

import { stationsActions } from '../reducer';

import { StationsState } from '../../types';

export const updateStationsDisplay = (display: StationsState['display']): AnyAction =>
  stationsActions.setStationsDisplay(display);
